import { defineStore } from 'pinia';
import {
  createBaseFilterState,
  createFilterActions,
  createFilterGetters,
} from './filterStoreHelpers';
import sortOptions from '@/constants/sortOptions';

const filterAPI = 'api/transport-requests/manage/Picked-Up';
const options = { sort: sortOptions.dispatchedDate };

export const usePickedUpFilterStore = defineStore('pickedUpFilterStore', {
  state: () => createBaseFilterState(options),
  actions: createFilterActions(filterAPI, options),
  getters: createFilterGetters(),
});
